import { ChangeDetectorRef, Injectable, inject } from '@angular/core';
import { DragAndDropModeService } from '@wilson/shift-timeline/services';
import { MoveAbsenceDropZoneHelperService } from '../../components/move-absence-drop-zone/move-absence-drop-zone-helper.service';
import { TimelineHelperService } from '@wilson/shift-timeline/services';
import { Absence } from '@wilson/interfaces';

@Injectable()
export class ClusterDragHelperService {
  private readonly moveAbsenceDropZoneHelperService = inject(
    MoveAbsenceDropZoneHelperService,
  );
  private readonly timelineHelperService = inject(TimelineHelperService);
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  private readonly cdRef = inject(ChangeDetectorRef);

  public startDragAbsence(
    event: DragEvent,
    left: number | null,
    right: number | null,
    absence: Absence,
    hasAbsenceUpdatePermissions: boolean,
  ): void {
    if (hasAbsenceUpdatePermissions) {
      const isDragStarted =
        this.moveAbsenceDropZoneHelperService.startDrag(absence);
      if (isDragStarted) {
        this.initiateDragAndDropAbsence(event, left, right);
      }
    } else {
      this.timelineHelperService.informUserHasNoPermissionsToMoveEntity();
    }
  }

  public dragEndAbsence(isMoveMode: boolean): void {
    this.moveAbsenceDropZoneHelperService.dragEnd(isMoveMode);
    this.cdRef.detectChanges();
  }

  private initiateDragAndDropAbsence(
    event: DragEvent,
    left: number | null,
    right: number | null,
  ): void {
    setTimeout(() => {
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'move';
      }
      this.moveAbsenceDropZoneHelperService.initiateDragAndDrop(left, right);
      this.cdRef.detectChanges();
    });
  }

  trackHorizontalDragAbsence(
    event: DragEvent,
    left: number | null,
    right: number | null,
    shiftDuration: number | null,
  ): void {
    if (left && right) {
      const offsetInPixels = (event as DragEvent & { layerX: number }).layerX;
      const trackedLeftPosition = left + offsetInPixels;
      const trackedRightPosition = right - offsetInPixels;

      const range = {
        left:
          trackedLeftPosition -
          DragAndDropModeService.SHADOW_SHIFT_ALLOWANCE_PIXEL,
        right:
          trackedRightPosition +
          DragAndDropModeService.SHADOW_SHIFT_ALLOWANCE_PIXEL,
        shiftDuration: shiftDuration,
        adjustmentNeeded: true,
      };
      this.dragAndDropModeService.setHorizontalDemarcatorRange(range);
    }
  }
}
